import { SpaceFileMimeType } from 'shared';

/**
 * Which renderer draws a file — one enum, so the viewer branches once.
 *
 * The server decides what may be shown at all (`isViewableInSpace`); this decides who draws it,
 * and the two meet at the content type the response carried. A type the server would refuse
 * cannot reach here, so `null` only ever means a response nobody expected.
 */
export enum PreviewKind {
  DOCX = 'docx',
  IMAGE = 'image',
  PDF = 'pdf',
  SHEET = 'sheet',
}

const KIND_BY_MIME_TYPE: Partial<Record<SpaceFileMimeType, PreviewKind>> = {
  [SpaceFileMimeType.CSV]: PreviewKind.SHEET,
  [SpaceFileMimeType.DOCX]: PreviewKind.DOCX,
  [SpaceFileMimeType.JPEG]: PreviewKind.IMAGE,
  [SpaceFileMimeType.PDF]: PreviewKind.PDF,
  [SpaceFileMimeType.PLAIN_TEXT]: PreviewKind.SHEET,
  [SpaceFileMimeType.PNG]: PreviewKind.IMAGE,
  [SpaceFileMimeType.XLSX]: PreviewKind.SHEET,
};

export const previewKindOf = (contentType: null | string): null | PreviewKind =>
  KIND_BY_MIME_TYPE[contentType as SpaceFileMimeType] ?? null;
